






















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import qs from 'query-string';

import AppProductWrap from '../ProductItem/ProductWrap.vue';
import { state } from '../../util/state';
import { AppState } from '../../util/app-state';

@Component({
  name: 'AppCompleteOrder',
  components: { AppProductWrap },
})
export default class CompleteOrder extends Vue {
  // computed
  get egrnObject(): Product {
    return state.products.byName.EgrnObject;
  }

  get rightList(): Product {
    return state.products.byName.EgrnRightList;
  }

  get egrnObjectWasPaid(): boolean {
    return state.orderItems.some((orderItem: OrderItem) => {
      return orderItem.product_id === this.egrnObject.product_id;
    });
  }

  get rightListPaid(): boolean {
    return state.orderItems.some((orderItem: OrderItem) => {
      return orderItem.product_id === this.rightList.product_id;
    });
  }

  get state(): AppState {
    return state;
  }

  // methods
  redirect(isPurchased: boolean) {
    const [ orderItem ] = state.orderItems;

    if (!orderItem) {
      return;
    }

    const query: any = { id: orderItem.order_item_id };

    if (!isPurchased) {
      query.redirect = 'order';
    }

    const objectKey = orderItem.object_key.replace(/\//, '%2F');
    const url = `https://egrn.realtycloud.ru/object/${objectKey}?${qs.stringify(query)}`;

    window.open(url);
  }
}
